import script from "./ODadosResponsabilidadeUsuario.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODadosResponsabilidadeUsuario.vue?vue&type=script&lang=ts&setup=true"

import "./ODadosResponsabilidadeUsuario.vue?vue&type=style&index=0&id=84603f1e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84603f1e"]])

export default __exports__